import { useEffect, useState } from 'react';

import { useModal } from 'context/ModalContext';

import ModalBonus from './bonus';
import { ConfirmacaoDaAcao, ResultadoDaAcao } from './moldura-da-acao';

interface Props {
  callback: (obj: { id: string; message?: string }) => void;
  id: string;
  status: string | undefined;
  data?: any;
  playerInfo?: any;
  bonus?: boolean;
}

export default function ModalPromote(props: Props) {
  const modalID = 'validation-promote';

  const { openModal, closeModal } = useModal();
  const { callback, id, data, playerInfo } = props;

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [success, setSuccess] = useState(false);
  const [bonusText, setBonusText] = useState(false);

  function handleClose() {
    closeModal();
    if (!!success) callback({ id: 'open_feedback' });
  }

  useEffect(() => {
    if (typeof id === 'string' && typeof openModal === 'string' && openModal === `${modalID}-${id}`) {
      setSuccess(false);
      setIsOpen(true);
    } else if (typeof id === 'string' && typeof openModal === 'string' && openModal === `${modalID}-${id}-finish`) {
      setSuccess(true);
      setIsOpen(true);
    } else {
      setSuccess(false);
      setIsOpen(false);
    }
  }, [id, openModal]);

  if (!modalIsOpen) return <></>;

  if (props?.bonus && !bonusText && !success) {
    return <ModalBonus onClose={() => closeModal()} onConfirm={() => setBonusText(true)} />;
  }

  if (success) {
    return (
      <ResultadoDaAcao title="Mandou bem!" onClose={handleClose}>
        {data.prosseguir_who_approved && data.prosseguir_who_approved === playerInfo?._id ? (
          <>
            A Realização Destaque foi enviada para o líder do <strong className="font-bold">próximo nível</strong> de apreciação.
          </>
        ) : (
          <>
            Sua apreciação foi realizada com sucesso e enviada para o líder do{' '}
            <strong className="font-bold">próximo nível</strong> de apreciação.
          </>
        )}
      </ResultadoDaAcao>
    );
  }

  const prosseguir = data.prosseguir_gst && data.prosseguir_gst === 'next';

  return (
    <ConfirmacaoDaAcao
      title={prosseguir ? 'Prosseguir realização' : 'Promover realização'}
      onClose={handleClose}
      onConfirm={() => {
        callback({ id: 'promote' });
        closeModal();
        setBonusText(false);
      }}
    >
      <p className="m-0">
        {prosseguir
          ? 'Esta entrega será enviada para apreciação do Nível 3. Deseja confirmar essa ação?'
          : `Você pode promover até ${data.stageNumber >= 2 ? '20%' : '10%'} do total de entregas bonificadas neste nível (com arredondamento para cima). Deseja confirmar essa ação?`}
      </p>
    </ConfirmacaoDaAcao>
  );
}
